/* =====================================================================
   LYMPHA — micro-interactions + CTA header
   Sans dépendance. Respecte prefers-reduced-motion.
   ===================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 0. Header : transparent dès qu'on défile ----------- */
  function setupHeaderScroll() {
    var root = document.documentElement;
    var last = null;
    function update() {
      var scrolled = (window.pageYOffset || document.documentElement.scrollTop || 0) > 40;
      if (scrolled !== last) {
        last = scrolled;
        root.classList.toggle('lh-scrolled', scrolled);
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ---------- 1. Bouton "Commander" dans le header ---------------- */
  function setupNavCta() {
    var icons = document.querySelector('.header__icons');
    if (!icons || document.querySelector('.lh-nav-cta')) return;
    var a = document.createElement('a');
    a.className = 'lh-nav-cta';
    a.href = '/products/set-4-outils-maderotherapie';
    a.textContent = 'Commander';
    icons.insertBefore(a, icons.firstChild);
  }

  /* ---------- 2. Révélation au scroll ---------------------------- */
  function setupReveal() {
    var targets = [];
    var groups = [
      '.lympha-steps__grid', '.lympha-benefits__grid', '.lwa-grid',
      '.lh-hero__left', '.lwa-header', '.lwa-banner', '.lwa-quote',
      '.image-with-text__content', '.image-with-text__media',
      '.collapsible-content .accordion', '.newsletter__wrapper',
      '.lympha-steps > .page-width', '.lympha-benefits > .page-width'
    ];

    groups.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.classList.contains('scroll-reveal')) return;
        el.classList.add('scroll-reveal');
        targets.push(el);
      });
    });

    ['.lympha-steps__grid', '.lympha-benefits__grid', '.lwa-grid'].forEach(function (sel) {
      var grid = document.querySelector(sel);
      if (!grid) return;
      Array.prototype.slice.call(grid.children).forEach(function (child, i) {
        child.style.setProperty('--reveal-delay', (i * 65) + 'ms');
      });
    });

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 3. Compteurs animés du héro ----------------------- */
  function animateCount(el) {
    var raw = (el.textContent || '').trim();
    var match = raw.match(/^([^\d]*)([\d]+(?:[.,][\d]+)?)(.*)$/);
    if (!match) return;
    var prefix = match[1], numStr = match[2], suffix = match[3];
    var decimals = (numStr.split(/[.,]/)[1] || '').length;
    var target = parseFloat(numStr.replace(',', '.'));
    var sepIsComma = numStr.indexOf(',') > -1;
    var start = null, dur = 1100;

    function fmt(v) {
      var s = v.toFixed(decimals);
      if (sepIsComma) s = s.replace('.', ',');
      return prefix + s + suffix;
    }
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * eased);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = fmt(target);
    }
    requestAnimationFrame(step);
  }

  function setupCounters() {
    var nums = document.querySelectorAll('.lh-hero__stat-n');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.6 });

    nums.forEach(function (el) { io.observe(el); });
  }

  function init() {
    setupHeaderScroll();
    setupNavCta();
    setupReveal();
    setupCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
